import React, { useState, useEffect, useContext } from "react";

import "./tenantDash.scss";

//import context
import { MyContext } from "../tenantsDashContext";

//import components
import MobileNav from "../Other-Page-Components/Tenant-Components/OverView/Mobile-and-Tablet/Mobile-Nav.jsx";
import TopSection from "../Other-Page-Components/Tenant-Components/OverView/Mobile-and-Tablet/Top-Section-Mobile.jsx";
import MiddleSectionOverview from "../Other-Page-Components/Tenant-Components/OverView/Mobile-and-Tablet/Mid-section-Mobile.jsx";
import Navigation from "../Other-Page-Components/Tenant-Components/OverView/Pc-and-Large-Screens/Dashboard.jsx";
import TopSectionPc from "../Other-Page-Components/Tenant-Components/OverView/Pc-and-Large-Screens/Top-Section-Pc.jsx";
import MiddleSectionPc from "../Other-Page-Components/Tenant-Components/OverView/Pc-and-Large-Screens/Mid-section-Pc.jsx";
import RightSectionPc from "../Other-Page-Components/Tenant-Components/OverView/Pc-and-Large-Screens/Right-Section.jsx";

//payment components
import MidSectionPayments from "../Other-Page-Components/Tenant-Components/Payments/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionPaymentsPc from "../Other-Page-Components/Tenant-Components/Payments/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

//messaging components
import MessagingApp from "../Other-Page-Components/Tenant-Components/Messaging/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

import MobileChat from "../Other-Page-Components/Tenant-Components/Messaging/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionInvoices from "../Other-Page-Components/Tenant-Components/Invoices/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionInvoicesPc from "../Other-Page-Components/Tenant-Components/Invoices/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

import MidSectionProfile from "../Other-Page-Components/Tenant-Components/Profile/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionProfilePc from "../Other-Page-Components/Tenant-Components/Profile/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

// Tour components
import TenantTour from "../Other-Page-Components/Tenant-Components/TourFiles/TenantTour.jsx";
import TenantTourMobile from "../Other-Page-Components/Tenant-Components/TourFiles/TenantTourMobile.jsx";
import TenantTourTablet from "../Other-Page-Components/Tenant-Components/TourFiles/TenantTourTablet.jsx";
import TenantWelcomeBanner from "../Other-Page-Components/Tenant-Components/TourFiles/TenantWelcomeBanner.jsx";
import TenantWelcomeBannerMobile from "../Other-Page-Components/Tenant-Components/TourFiles/TenantWelcomeBannerMobile.jsx";
import TenantWelcomeBannerTablet from "../Other-Page-Components/Tenant-Components/TourFiles/TenantWelcomeBannerTablet.jsx";
import useTenantTour from "../hooks/useTenantTour.js";
import useTenantTourMobile from "../hooks/useTenantTourMobile.js";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

const TenantDash = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const {
    shouldShowTour,
    shouldShowWelcome,
    resumeAtStep,
    startTour,
    endTour,
    dismissWelcome,
    resetTour,
    resumeTourAtStep,
  } = useTenantTour();

  // Mobile/Tablet tour hook
  const {
    shouldShowTour: shouldShowMobileTour,
    shouldShowWelcome: shouldShowMobileWelcome,
    deviceType,
    resumeAtStep: resumeAtStepMobile,
    startTour: startMobileTour,
    endTour: endMobileTour,
    dismissWelcome: dismissMobileWelcome,
    resetTour: resetMobileTour,
    resumeTourAtStep: resumeTourAtStepMobile,
  } = useTenantTourMobile();

  const { user } = useSelector((state) => state.landlordslice);
  //  check  window size
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setIsMobileScreen(true);
    } else {
      setIsMobileScreen(false);
    }
  }, []);

  // check if window size changes
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        setIsMobileScreen(true);
      } else {
        setIsMobileScreen(false);
      }
    }
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div className="tenant-dashboard">
      {/* Welcome Banner - Only for PC/Large screens on first visit */}
      {!isMobileScreen && shouldShowWelcome && sharedValue === "Overview" && (
        <TenantWelcomeBanner
          userName={user?.data?.user?.user_name || "Tenant"}
          onStartTour={startTour}
          onDismiss={dismissWelcome}
        />
      )}

      {/* Welcome Banner - Mobile/Tablet on first visit */}
      {isMobileScreen &&
        shouldShowMobileWelcome &&
        sharedValue === "Overview" && (
          <>
            {deviceType === "mobile" && (
              <TenantWelcomeBannerMobile
                userName={user?.data?.user?.user_name || "Tenant"}
                onStartTour={startMobileTour}
                onDismiss={dismissMobileWelcome}
              />
            )}
            {deviceType === "tablet" && (
              <TenantWelcomeBannerTablet
                userName={user?.data?.user?.user_name || "Tenant"}
                onStartTour={startMobileTour}
                onDismiss={dismissMobileWelcome}
              />
            )}
          </>
        )}

      {/* Tour Components - Only for PC/Large screens */}
      {!isMobileScreen &&
        shouldShowTour &&
        (sharedValue === "Overview" ||
          (resumeAtStep !== null && resumeAtStep >= 2)) && (
          <TenantTour
            runTour={shouldShowTour}
            onTourEnd={endTour}
            setSharedValue={setSharedValue}
            sharedValue={sharedValue}
            resumeAtStep={resumeAtStep}
          />
        )}

      {/* Tour Components - Mobile/Tablet */}
      {isMobileScreen &&
        shouldShowMobileTour &&
        (sharedValue === "Overview" ||
          (resumeAtStepMobile !== null && resumeAtStepMobile >= 2)) && (
          <>
            {deviceType === "mobile" && (
              <TenantTourMobile
                runTour={shouldShowMobileTour}
                onTourEnd={endMobileTour}
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                resumeAtStep={resumeAtStepMobile}
              />
            )}
            {deviceType === "tablet" && (
              <TenantTourTablet
                runTour={shouldShowMobileTour}
                onTourEnd={endMobileTour}
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                resumeAtStep={resumeAtStepMobile}
              />
            )}
          </>
        )}

      {isMobileScreen ? (
        <>
          {sharedValue === "Overview" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                onStartTour={startMobileTour}
                deviceType={deviceType}
              />
              <MiddleSectionOverview />
            </>
          )}

          {sharedValue === "Payments" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                onStartTour={startMobileTour}
                deviceType={deviceType}
              />
              <MidSectionPayments />
            </>
          )}
          {sharedValue === "Invoices" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                onStartTour={startMobileTour}
                deviceType={deviceType}
              />
              <MidSectionInvoices />
            </>
          )}
          {sharedValue === "Messages" && (
            <>
              <MobileChat
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
            </>
          )}
          {sharedValue === "Profile" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
                onStartTour={startMobileTour}
                deviceType={deviceType}
              />
              <MidSectionProfile
                resumeTourAtStep={resumeTourAtStepMobile}
                setSharedValue={setSharedValue}
                isTourActive={shouldShowMobileTour}
              />
            </>
          )}
          <MobileNav />
        </>
      ) : (
        <>
          <div className="pc-container">
            <Navigation />

            <div className="right">
              <TopSectionPc startTour={startTour} resetTour={resetTour} />
              {sharedValue === "Overview" && (
                <>
                  <div className="mid-section">
                    <div className="mid-left">
                      <MiddleSectionPc />
                    </div>
                    <div className="mid-right">
                      <RightSectionPc />
                    </div>
                  </div>
                </>
              )}

              {sharedValue === "Payments" && (
                <>
                  <MidSectionPaymentsPc />
                </>
              )}
              {sharedValue === "Invoices" && (
                <>
                  <MidSectionInvoicesPc />
                </>
              )}
              {sharedValue === "Messages" && (
                <>
                  <MessagingApp />
                </>
              )}
              {sharedValue === "Profile" && (
                <>
                  <MidSectionProfilePc
                    resumeTourAtStep={resumeTourAtStep}
                    setSharedValue={setSharedValue}
                    isTourActive={shouldShowTour}
                  />
                </>
              )}
              {sharedValue === "Tour" && (
                <>
                  <TenantTour />
                </>
              )}
            </div>
          </div>
        </>
      )}
      {/* */}
    </div>
  );
};

export default TenantDash;
